module.exports = __webpack_public_path__ + "assets/img/ic-cash-remittance.2400f12c.svg";